// @flow
export default (props) => {
  switch (props.decorator || props.is) {
    case 'EshopPhotogallery':
      // ESHOP: Produktova fotogalerie
      return import('./components/EshopPhotogallery');
    case 'EshopModel3D':
      // ESHOP: 3D model v ramci produktove fotogalerie (odeberte, pokud neni pozadovana funkcionalita 3D modelu (nastavitelne na fotogalerii))
      return import('fg-frontend/components/EshopModel3D');
    case 'EshopImageZoom':
      return import('./components/EshopImageZoom');
    case 'EshopGalleryPopup':
      return import('./components/EshopGalleryPopup');
    case 'EshopOrderForm':
      return import('fg-frontend/components/EshopOrderForm');
      // ESHOP: fulltextovy naseptavac, povolte, pokud je aktivni fulltext feature
    case 'EshopFulltextAutocomplete':
      return import('./components/EshopFulltextAutocomplete');
    case 'ProductListSlider':
      return import('fg-frontend/components/ProductListSlider');
    // eshop - detail produktu - komponenta productDetailVariantForm - odkomentovat, pokud je na komponente nastaveno metadato <enableVariantStockHandler>true</enableVariantStockHandler>
    case 'EshopVariantStockHandler':
      return import('./components/EshopVariantStockHandler');
/*    case 'CategorySort':
      return import('./components/CategorySort');*/
/*    case 'MobileCategorySort':
      return import('./components/MobileCategorySort');*/
    case 'BranchPicker':
      // ESHOP: vyber pobocky v ramci vybranych doprav - povolte, kdyz mate na widgetu pro vyber dopravy nastavene metadato <enableBranchPicker>true</enableBranchPicker>
      return import('./components/BranchPicker');
    case 'EshopUserToolsHandler':
      // ESHOP: Handler komponenta pro pridani/odebrani produktu z oblibenych/porovnavani (odeberte, pokud na projektu nepouzivate ani oblibene ani porovnavani)
      return import('./components/EshopUserToolsHandler');
    case 'GoToCategory':
      // ESHOP: ovlada tlacitko pro navrat zpet z detailu produktu
      return import('./components/GoToCategory');
    case 'EshopProductListTile':
      // ESHOP: pokročilé funkce dlaždice
      return import('./components/EshopProductListTile');
    case 'RadioSelect':
      // COMMON: Podpurna komponenta pro radio select group, ktera zpropaguje change eventu pro ucely PU (odeberte, pokud nepouzivate ve vypisu katalogu komponentu pro razeni ani komponenta pro prepnuti zobrazeni)
      return import('fg-frontend/src/components/RadioSelect');
    case 'CheckboxSelect':
      // COMMON: Komponenta pro podporu hromadneho zaskrtnuti ve skupine checkboxu (odeberte pokud nepouzivate ve vypisech produktu komponenty pro checkboxovou filtraci tagFilter, brandFilter, parameterFilter)
      return import('fg-frontend/src/components/CheckboxSelect');
    case 'NumberInput':
      // COMMON Komponenta pro nastaveni ciselneho mnozstvi (odeberte, pokud v projektu neni nakupni proces)
      return import('fg-frontend/components/NumberInput');
    case 'ListToggle':
      // COMMON: Komponenta pro skryti/zobrazeni casti seznamu (odeberte pokud nepouzivate Nejprodavanejsi produkty ve vypisu produktu, ani vypis parametru v detailu produktu, ani nemate v projektu nakupni proces)
      return import('fg-frontend/components/ListToggle');
    case 'RangeDatepicker':
      // COMMON: Komponenta intervaloveho datepickeru (odeberte, pokud nepouzivate Objednavky v B2B rezimu, nebo Faktury)
      return import('fg-frontend/components/RangeDatepicker');
    case 'AnchorsList':
      // COMMON: Zalozkovy seznam s kotvami (odeberte, pokud nepouzivate v detailu produktu)
      return import('fg-frontend/src/components/AnchorsList');
    case 'RadioSelectTab':
      // COMMON: Komponenta pro zobrazeni skupiny radio buttonu formou zalozek (odeberte, pokud nepouzivate vychozi komponentu pro razeni produktu)
      return import('fg-frontend/src/components/RadioSelectTab');
    case 'ShareUrl':
      // COMMON: Komponenta, ktera zkopiruje danou URL, resp. string do schranky (odeberte, pokud nepouzivate funkci Ziskat odkaz v detailu produktu ani Sdileni kosiku)
      return import('fg-frontend/src/components/ShareUrl');
    case 'PrintPdf':
      // COMMON: Komponenta, ktera zajistuje tisk PDF (odeberte, pokud nepouzivate Faktury)
      return import('fg-frontend/src/components/PrintPdf');
    case 'RedirectToUrl':
      // COMMON: Komponenta, ktera zajistuje presmerovani po casovem intervalu (odeberte, pokud nepouzivate zadnou platebni branu)
      return import('fg-frontend/src/components/RedirectToUrl');
    case 'Form':
      // COMMON: Komponenta pro osetreni HTML formu (odeberte, pokud nepouzivate vyber variant ve vypisu produktu ani objednavkovy pruvodce)
      return import('fg-frontend/src/components/Form');
    case 'FileInput':
      // COMMON: Komponenta pro vlozeni jedineho souboru (odeberte, pokud nepouzivate Import objednavky z CVS)
      return import('fg-frontend/src/components/FileInput');
    case 'FilterOfFilter':
      // ESHOP: Komponenta pro filtraci hodnot ve filtracni komponente
      return import('./components/FilterOfFilter');
    case 'FilterHandler':
      // ESHOP: Handler filtrace
      return import('./components/FilterHandler');
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopComponents.js